import { ClientMetadata } from 'magpie-types';
import { Level, LogHandler, LogRecord } from 'simple-logging-lib';
function stableColorForString(input: string): string {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
    // eslint-disable-next-line no-bitwise
    hash = hash & hash; // Convert to 32-bit integer
  }

  const hue = Math.abs(hash) % 360;
  const saturation = 80;
  const lightness = 40;

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

export class MagpieDebugHandler extends LogHandler {
  level = Level.DEBUG;

  constructor(private readonly metadata: ClientMetadata) {
    super();
  }

  isLoggable = ({ level }: LogRecord): boolean => level === Level.DEBUG;

  publish(record: LogRecord): void {
    if (!this.isLoggable(record)) {
      return;
    }
    const { loggerName, messages } = record;
    const { appName } = this.metadata;
    console.log(
      `%c[${loggerName}] %c[${appName}]`,
      'color: #444; font-weight: bold;',
      `color: ${stableColorForString(appName)};`,
      ...messages
    );
  }
}

export class MagpieErrorHandler extends LogHandler {
  level = Level.ERROR;

  constructor(private readonly metadata: ClientMetadata) {
    super();
  }

  isLoggable = ({ level }: LogRecord): boolean => level === Level.ERROR;

  publish(record: LogRecord): void {
    if (!this.isLoggable(record)) {
      return;
    }
    const { appName } = this.metadata;
    const { loggerName, messages } = record;
    console.error(
      `%c[${loggerName}] %c[${appName}]`,
      'color: #444; font-weight: bold;',
      `color: ${stableColorForString(appName)};`,
      ...messages
    );
  }
}
